/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Composer_LabelInputs */

const en_us2_coach_composer_label = /** @type {(inputs: Coach_Composer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message to your trainer`)
};

const pt_br2_coach_composer_label = /** @type {(inputs: Coach_Composer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem para o seu personal`)
};

const es_419_coach_composer_label = /** @type {(inputs: Coach_Composer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje para tu entrenador`)
};

const pt_pt2_coach_composer_label = /** @type {(inputs: Coach_Composer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem para o teu treinador`)
};

const fr_fr2_coach_composer_label = /** @type {(inputs: Coach_Composer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message à ton coach`)
};

const de_de2_coach_composer_label = /** @type {(inputs: Coach_Composer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht an deinen Coach`)
};

const it_it2_coach_composer_label = /** @type {(inputs: Coach_Composer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio al tuo coach`)
};

/**
* | output |
* | --- |
* | "Message to your trainer" |
*
* @param {Coach_Composer_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_composer_label = /** @type {((inputs?: Coach_Composer_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Composer_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_composer_label(inputs)
	if (locale === "es-419") return es_419_coach_composer_label(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_composer_label(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_composer_label(inputs)
	if (locale === "de-DE") return de_de2_coach_composer_label(inputs)
	if (locale === "it-IT") return it_it2_coach_composer_label(inputs)
	return en_us2_coach_composer_label(inputs)
});
export { coach_composer_label as "coach.composer_label" }